export default __webpack_public_path__ + "static/media/fast-forward.c2de8ade.svg";